import { useState } from 'react';
import { useLang } from '../i18n/LanguageContext';
import { useCart } from '../context/CartContext';
import { formatVND, effectivePrice, pickLang } from '../lib/format';

export default function ComboCard({ combo }) {
  const { lang, t } = useLang();
  const { add } = useCart();
  const [added, setAdded] = useState(false);

  const price = effectivePrice(combo);
  const onSale = Number(combo.sale_price) && Number(combo.sale_price) < Number(combo.price);
  const items = combo.combo_items || [];

  const handleAdd = () => {
    add({ kind: 'combo', id: combo.id, name: combo.name, name_en: combo.name_en, price, category: 'combo' });
    setAdded(true);
    setTimeout(() => setAdded(false), 1200);
  };

  return (
    <div className="pcard">
      <div className="pcard-img">🎁</div>
      <div className="pcard-body">
        <div><span className="badge badge-sale">COMBO</span></div>
        <div className="pcard-name">{pickLang(combo, 'name', lang)}</div>
        <div className="pcard-desc">
          {pickLang(combo, 'description', lang)}
          {items.length > 0 && (
            <div style={{ marginTop: 6 }}>
              <strong>{t('p.includes')}:</strong>{' '}
              {items.map((ci) => pickLang(ci.products || {}, 'name', lang)).filter(Boolean).join(' + ')}
            </div>
          )}
        </div>
        <div>
          <span className="price">{formatVND(price)}</span>
          {onSale && <span className="price-old">{formatVND(combo.price)}</span>}
        </div>
        <button className="btn btn-primary btn-sm" onClick={handleAdd}>
          {added ? t('p.added') : t('p.addToCart')}
        </button>
      </div>
    </div>
  );
}
